import {
  APP_URL,
  JW_APP_URL,
  SCHOOL_INFO,
  USER_TOKEN,
  USER_ID,
  WECOM_CORP_ID,
} from "@/config/constants";
import { isFromWelink } from "@/layouts/hooks/useIsFromWelink";
import { getBackUrl } from "@/utils/toolUtls";
import { isJwInlandApp, isJwIntlApp } from "@/utils/app/env";

/** 快排课专用 cookie；禁止写 baseToken.school / 旧 baseToken */
export const PRODUCT_BASE_TOKEN_COOKIE = "baseToken.kuaipk";

function getCookieMap() {
  return document.cookie.split(";").reduce((map, item) => {
    const trimmed = item.trim();
    if (!trimmed) return map;
    const eq = trimmed.indexOf("=");
    if (eq <= 0) return map;
    map[trimmed.slice(0, eq).trim()] = trimmed.slice(eq + 1);
    return map;
  }, {} as Record<string, string>);
}

function getEffectiveDomain() {
  return window.location.hostname.split(".").slice(-2).join(".");
}

// 设置本产品 token 到 cookie
export function setBaseToken2cookie(memberToken: string) {
  document.cookie = `${PRODUCT_BASE_TOKEN_COOKIE}=${memberToken};domain=${getEffectiveDomain()};path=/`;
}

// 移除本产品 cookie（不清智校/其他产品 key）
export function removeBaseToken2Cookie() {
  document.cookie = `${PRODUCT_BASE_TOKEN_COOKIE}="";domain=${getEffectiveDomain()};max-age=-1;path=/`;
}

// 从本产品 cookie 获取 token
export function getBaseToken2cookie() {
  return getCookieMap()[PRODUCT_BASE_TOKEN_COOKIE];
}

// 获取 token：只认本产品 key，否则 localStorage（忽略旧 baseToken / school）
export function getUserToken() {
  const baseToken = getBaseToken2cookie();
  if (baseToken) {
    localStorage.setItem(USER_TOKEN, baseToken);
    return baseToken;
  }
  return localStorage.getItem(USER_TOKEN);
}

export function removeUserTokenWithRelation() {
  removeBaseToken2Cookie();

  localStorage.removeItem(USER_TOKEN);
  localStorage.removeItem(USER_ID);
  localStorage.removeItem(SCHOOL_INFO);
  localStorage.removeItem(WECOM_CORP_ID);
  sessionStorage.removeItem("isFromWelink");
}

export function logout() {
  removeUserTokenWithRelation();

  if (isFromWelink()) {
    window.location.href = `${APP_URL}#/welink-login`;
    return;
  }

  if (isJwInlandApp || isJwIntlApp) {
    window.location.href = `${JW_APP_URL}#/login?backApp=kuaipk&backUrl=${getBackUrl()}`;
    return;
  }

  window.location.href = `${APP_URL}#/login?backUrl=${getBackUrl()}`;
}
